import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { BIZ } from "@/data/site";
import { useLang } from "@/i18n/LanguageContext";

export const MobileCallBar = () => {
  const { t } = useLang();
  return (
  <div className="no-print fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-[var(--line)] bg-white md:hidden" data-testid="mobile-call-bar">
    <a href={BIZ.phoneHref} className="flex items-center justify-center gap-2 py-4 text-[15px] font-semibold text-[var(--ink)]" data-testid="mobile-call-button">
      <Phone size={16} strokeWidth={1.75} /> {t("Call us")}
    </a>
    <Link to="/quote" className="flex items-center justify-center bg-[var(--accent-deep)] py-4 text-[15px] font-semibold text-white" data-testid="mobile-quote-button">
      {t("Get my quote")}
    </Link>
  </div>
  );
};
